import {ChangeDetectionStrategy, Component} from '@angular/core';
import {UsersMainComponent} from './../../users/users-main/users-main.component';

@Component({
  selector: 'people-users-wrapper',
  standalone: true,
  imports: [UsersMainComponent],
  templateUrl: './people-users-wrapper.component.html',
  styleUrl: './people-users-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleUsersWrapperComponent {}
